// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/Manrope-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/Manrope-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/Manrope-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/Manrope-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@font-face {
  font-family: 'Manrope';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  font-display: swap;
  font-weight: 400;
}

@font-face {
  font-family: 'Manrope';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
  font-display: swap;
  font-weight: 500;
}

@font-face {
  font-family: 'Manrope';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
  font-display: swap;
  font-weight: 700;
}

@font-face {
  font-family: 'Manrope';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2');
  font-display: swap;
  font-weight: 800;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  letter-spacing: 0.02em;
}

::-webkit-scrollbar {
  width: 0; /* ширина для вертикального скролла */
  height: 0; /* высота для горизонтального скролла */
  background-color: #143861;
}

:root {
  --text-size: 16px;
  --text-lineheight: 22px;
  --padding-input: 20px 25px;
  --blue-main: rgba(54, 110, 255, 1);
  --text-grey: #33353a;
}

@media (max-width: 1600px) {
  :root {
    --text-size: 16px;
    --text-lineheight: 22px;
    --padding-input: 15px 20px;
    --blue-main: rgba(54, 110, 255, 1);
  }
}

@media (max-width: 1440px) {
  :root {
    --text-size: 14px;
    --text-lineheight: 20px;
    --padding-input: 15px 20px;
    --blue-main: rgba(54, 110, 255, 1);
  }
}

img {
  margin: 0;
  padding: 0;
}

ul {
  list-style-type: none;
}

a {
  text-decoration: none;
  color: inherit;
}

.registration {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
}

.reg-background {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.logo-reg {
  position: absolute;
  width: 100px;
  top: 30px;
  left: 30px;
}

.video-reg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
}

.container-registration {
  display: flex;
  width: 476px;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px;
  gap: 15px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.6) 100%);
  backdrop-filter: blur(50px);
  --webkit-backdrop-filter: blur(50px);
  border-radius: 10px;
}

@media (max-width: 600px) {
  .container-registration {
    display: flex;
    width: 90%;
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
    gap: 15px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.6) 100%);
    backdrop-filter: blur(50px);
    --webkit-backdrop-filter: blur(50px);
    border-radius: 10px;
  }
}

.registration-nav {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.reg-nav-item {
  display: inline-block;
}

.reg-link {
  display: inline-block;
  font-size: 18px;
  line-height: 18px;
  font-weight: 800;
}

.active {
  color: var(--blue-main);
}

.code-error {
  color: blue;
  text-decoration: solid;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,4DAAuD;EACvD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,4DAAsD;EACtD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,4DAAoD;EACpD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,4DAAyD;EACzD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,QAAQ,EAAE,qCAAqC;EAC/C,SAAS,EAAE,uCAAuC;EAClD,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;EAC1B,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE;IACE,iBAAiB;IACjB,uBAAuB;IACvB,0BAA0B;IAC1B,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,uBAAuB;IACvB,0BAA0B;IAC1B,kCAAkC;EACpC;AACF;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,8FAA8F;EAC9F,2BAA2B;EAC3B,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,UAAU;IACV,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,SAAS;IACT,8FAA8F;IAC9F,2BAA2B;IAC3B,oCAAoC;IACpC,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":["\n@font-face {\n  font-family: 'Manrope';\n  src: url('fonts/Manrope-Regular.woff2') format('woff2');\n  font-display: swap;\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: 'Manrope';\n  src: url('fonts/Manrope-Medium.woff2') format('woff2');\n  font-display: swap;\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: 'Manrope';\n  src: url('fonts/Manrope-Bold.woff2') format('woff2');\n  font-display: swap;\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: 'Manrope';\n  src: url('fonts/Manrope-ExtraBold.woff2') format('woff2');\n  font-display: swap;\n  font-weight: 800;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Manrope', sans-serif;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n}\n\n::-webkit-scrollbar {\n  width: 0; /* ширина для вертикального скролла */\n  height: 0; /* высота для горизонтального скролла */\n  background-color: #143861;\n}\n\n:root {\n  --text-size: 16px;\n  --text-lineheight: 22px;\n  --padding-input: 20px 25px;\n  --blue-main: rgba(54, 110, 255, 1);\n  --text-grey: #33353a;\n}\n\n@media (max-width: 1600px) {\n  :root {\n    --text-size: 16px;\n    --text-lineheight: 22px;\n    --padding-input: 15px 20px;\n    --blue-main: rgba(54, 110, 255, 1);\n  }\n}\n\n@media (max-width: 1440px) {\n  :root {\n    --text-size: 14px;\n    --text-lineheight: 20px;\n    --padding-input: 15px 20px;\n    --blue-main: rgba(54, 110, 255, 1);\n  }\n}\n\nimg {\n  margin: 0;\n  padding: 0;\n}\n\nul {\n  list-style-type: none;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n.registration {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  width: 100%;\n}\n\n.reg-background {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n}\n\n.logo-reg {\n  position: absolute;\n  width: 100px;\n  top: 30px;\n  left: 30px;\n}\n\n.video-reg {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: -1;\n}\n\n.container-registration {\n  display: flex;\n  width: 476px;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 30px;\n  gap: 15px;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.6) 100%);\n  backdrop-filter: blur(50px);\n  --webkit-backdrop-filter: blur(50px);\n  border-radius: 10px;\n}\n\n@media (max-width: 600px) {\n  .container-registration {\n    display: flex;\n    width: 90%;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 20px;\n    gap: 15px;\n    background: linear-gradient(90deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.6) 100%);\n    backdrop-filter: blur(50px);\n    --webkit-backdrop-filter: blur(50px);\n    border-radius: 10px;\n  }\n}\n\n.registration-nav {\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.reg-nav-item {\n  display: inline-block;\n}\n\n.reg-link {\n  display: inline-block;\n  font-size: 18px;\n  line-height: 18px;\n  font-weight: 800;\n}\n\n.active {\n  color: var(--blue-main);\n}\n\n.code-error {\n  color: blue;\n  text-decoration: solid;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
